import * as React from "react"
import {Box, Typography} from '@mui/material'
import {formatPrice} from "@ui-seeker/utils";

import {LinkIconBlock} from "@components";

export default function productColumn() {
    return {
        name: 'Nombre producto',
        label: 'Producto',
        options: {
            customBodyRowRenderLite: (value, row) => {
                return <Box sx={{ display: "flex", flexDirection: "column", alignItems: 'center', gap: 0.5 }}>

                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                        <Typography component="span" fontWeight="bold">Nombre:</Typography>
                        <Typography variant="body2" sx={{ ml: 1 }}>{row['Nombre producto']}</Typography>
                    </Box>

                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                        <Typography component="span" fontWeight="bold">Variante:</Typography>
                        <Typography variant="body2" sx={{ ml: 1 }}>{row.Variante}</Typography>
                    </Box>

                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                        <Typography component="span" fontWeight="bold">SKU Primor:</Typography>
                        <Typography variant="body2" sx={{ ml: 1 }}>{row['SKU Primor']}</Typography>
                    </Box>

                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                        <Typography component="span" fontWeight="bold">SKU Druni:</Typography>
                        <Typography variant="body2" sx={{ ml: 1 }}>
                            <LinkIconBlock
                                url={row['URL Druni']}
                                iconProps={{ fontSize: '0.9rem' }}
                                textProps={{ fontSize: '0.9rem' }}
                            >
                                {row['SKU Druni']}
                            </LinkIconBlock>
                        </Typography>
                    </Box>

                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                        <Typography component="span" fontWeight="bold">Precio Maximo (Primor):</Typography>
                        <Typography variant="body2" sx={{ ml: 1 }}>{formatPrice(row['Maximo (con IVA) (Primor)'], 'EUR')}</Typography>
                    </Box>

                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                        <Typography component="span" fontWeight="bold">Precio Minimo (Primor):</Typography>
                        <Typography variant="body2" sx={{ ml: 1 }}>{formatPrice(row['Minimo (con IVA) (Primor)'], 'EUR')}</Typography>
                    </Box>

                </Box>
            }
        }
    }
}